module.exports = __webpack_public_path__ + "img/logo-headline65x400.6feed5f4.png";